import * as events from "../events/library/libraryEvents";

import {
  createDraftSuccess,
  publishSuccess,
  revertSuccess,
  successAction,
  updateSuccess,
} from "features/Library/EmbeddedVideos/state/EmbeddedVideosEntityStateSlice";
import { type Dispatcher, type MidnightActionPayload } from "../../../../../interfaces";
import * as backgroundTasksActions from "../../../../BackgroundTasks/state/backgroundTasksActions";
import {
  updateFailedTaskDistributedOperation,
  updateSucceededTaskDistributedOperation,
} from "../../../../BackgroundTasks/state/backgroundTasksActions";
import { createDispatcher } from "../dispatcher";
import { type IMapping } from "./types";

export const embeddedVideosMapping = (mapping: IMapping, dispatcher: Dispatcher) => {
  const {
    dispatch,
    dispatchPublishSuccess,
    dispatchBatchOperationSuccess,
    dispatchBatchOperationFailure,
    dispatchMap,
  } = createDispatcher(dispatcher);

  mapping[events.EmbeddedVideoPublishSuccess] = dispatchPublishSuccess<{ id: number; message: string }>(
    publishSuccess,
    (data) => data.message,
  );

  mapping[events.EmbeddedVideoDiscardSuccess] = dispatch(revertSuccess);
  mapping[events.LockEmbeddedVideoSuccess] = dispatchMap<{ id: number }, MidnightActionPayload>(
    createDraftSuccess,
    (message) => ({ entityId: message.id }),
  );
  mapping[events.EmbeddedVideoEditSuccess] = dispatchMap<{ id: number }, MidnightActionPayload>(
    updateSuccess,
    (message) => ({ entityId: message.id }),
  );
  mapping[events.EmbeddedVideoUpdateCommandCompleted] = dispatch(successAction);

  mapping[events.EmbeddedVideoTagsAddSuccess] = dispatchBatchOperationSuccess;
  mapping[events.EmbeddedVideoTagsAddFailure] = dispatchBatchOperationFailure;
  mapping[events.EmbeddedVideoTagsEditSuccess] = dispatch(successAction);

  mapping[events.EmbeddedVideoDeletionSuccess] = (payload) =>
    dispatcher(backgroundTasksActions.updateProgressTaskDistributedOperation(payload.operationId, payload.stepId));
  mapping[events.EmbeddedVideoDeletionFailure] = (payload) =>
    dispatcher(updateFailedTaskDistributedOperation(payload.operationId));
  mapping[events.DeleteAllEmbeddedVideoSuccess] = (payload) =>
    dispatcher(updateSucceededTaskDistributedOperation(payload.operationId));
  mapping[events.DeleteAllEmbeddedVideoFailure] = (payload) =>
    dispatcher(updateFailedTaskDistributedOperation(payload.operationId));

  mapping[events.EmbeddedVideoChangeVisibilitySuccess] = (payload) =>
    dispatcher(backgroundTasksActions.updateProgressTaskDistributedOperation(payload.operationId, payload.stepId));
  mapping[events.EmbeddedVideoChangeVisibilityFailure] = (payload) =>
    dispatcher(updateFailedTaskDistributedOperation(payload.operationId));
  mapping[events.EmbeddedVideoEditVisibilityAllSuccess] = (payload) =>
    dispatcher(updateSucceededTaskDistributedOperation(payload.operationId));
  mapping[events.EmbeddedVideoEditVisibilityAllFailure] = (payload) =>
    dispatcher(updateFailedTaskDistributedOperation(payload.operationId));

  mapping[events.EmbeddedVideoDuplicateSuccess] = (payload) =>
    dispatcher(updateSucceededTaskDistributedOperation(payload.operationId));
  mapping[events.EmbeddedVideoDuplicateFailure] = (payload) =>
    dispatcher(updateFailedTaskDistributedOperation(payload.operationId));
  mapping[events.EmbeddedVideoDuplicateAllSuccess] = (payload) =>
    dispatcher(updateSucceededTaskDistributedOperation(payload.operationId));
  mapping[events.EmbeddedVideoDuplicateAllFailure] = (payload) =>
    dispatcher(updateFailedTaskDistributedOperation(payload.operationId));
};
